export const AUTH_TOKEN_KEY = 'accessToken';
export const TENANT_ID_KEY = 'currentTenantId';

export function getAuthToken(): string {
  return localStorage.getItem(AUTH_TOKEN_KEY) || '';
}

export function getAuthHeaders(): HeadersInit {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function getAuthHeadersJson(): HeadersInit {
  return { 'Content-Type': 'application/json', ...getAuthHeaders() };
}

export function getCurrentTenantId(fallback = ''): string {
  return localStorage.getItem(TENANT_ID_KEY) || fallback;
}
